module.exports = __webpack_public_path__ + "static/media/adv2.6aad2fc6.jpg";